// extracted by mini-css-extract-plugin
export default {"faqContainer":"FAQPage_faqContainer__kRHH9","faqList":"FAQPage_faqList__gmHSa","faqItem":"FAQPage_faqItem__RLaR8"};